module.exports = __webpack_public_path__ + "img/pineapple-juice.5a625d37.jpg";